import { isNullOrUndefined, findRule } from '../Utils';

const validate = (vObj) => {
  const { value } = vObj;
  const rule = findRule(vObj.errorBag, 'minint');
  const min = parseInt(rule.ruleParams, 0);

  rule.feedback = `${vObj.fieldlabel} should be equal to or more than ${min}`;

  if (isNullOrUndefined(value)) {
    return min >= 0;
  }

  return parseInt(value, 10) <= min;
};

export { validate };

export default {
  validate,
};
